

export interface ILegacyQuotaSnapshotData {
}

export interface IEntitlementsData extends ILegacyQuotaSnapshotData {
	readonly access_type_sku: string;
	readonly copilot_plan: string;
}

export interface IDefaultAccount {
	readonly entitlementsData?: IEntitlementsData | null;
}
